/* ---------------------------------------------------------------------------
   SFD product card: the Add to quote button

   One delegated listener on the document, so it covers every card on the page
   and any card added later by a filter or a Load more, with no per-card
   handlers and nothing to re-bind.

   Only single-variant cards carry the button. Everything else links to the
   product page, because adding an unchosen size to a formal quote is worse
   than one more click. See snippets/sfd-product-card.liquid.

   window.addToQuote comes from assets/quote-basket.js, which is loaded site
   wide. If it is not there yet the button falls back to the product page
   rather than doing nothing, which is the one behaviour a customer cannot
   recover from on their own.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sfdc-quote]');
    if (!btn) return;

    e.preventDefault();

    var url = btn.getAttribute('data-url');

    if (typeof window.addToQuote !== 'function') {
      if (url) window.location.href = url;
      return;
    }

    var label = btn.textContent;

    try {
      window.addToQuote(
        btn.getAttribute('data-id'),
        1,
        btn.getAttribute('data-title'),
        btn.getAttribute('data-variant'),
        parseInt(btn.getAttribute('data-price'), 10) || 0,
        btn.getAttribute('data-img'),
        url,
        null
      );
    } catch (err) {
      if (url) window.location.href = url;
      return;
    }

    /* The quote drawer opens itself. This is only so the card acknowledges
       the click on a page where the drawer is slow to appear. */
    btn.textContent = 'Added to quote';
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = label;
      btn.disabled = false;
    }, 1800);
  });
})();
